import { Timestamp } from 'firebase/firestore';

/**
 * ワクチンの種類
 */
export type VaccinationType =
  | 'rabies' // 狂犬病
  | 'mixed_2_3' // 2〜3種混合
  | 'mixed_4' // 4種混合
  | 'mixed_5'; // 5種混合

/**
 * ワクチン接種記録（Firestore 保存モデル）
 *
 * `dogs/{dogId}/vaccinations/{vaccinationId}` サブコレクションに保存する。
 * 既存の Dog 型と同様、日付は Firestore の Timestamp で保持する。
 */
export interface VaccinationRecord {
  id: string;
  dogId: string;
  /** 親 Dog の ownerId（コレクショングループ検索・アクセス制御用） */
  ownerId: string;
  type: VaccinationType;
  /** 接種日 */
  vaccinatedAt: Timestamp;
  /** 次回期限（rabies は接種日 + 1 年で自動計算） */
  nextDueDate?: Timestamp;
  /** クリニック名（任意） */
  clinicName?: string;
  /** 備考（任意） */
  notes?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  createdBy: string;
}

/**
 * ワクチン接種記録フォームデータ（日付は Date）
 */
export interface VaccinationFormData {
  type: VaccinationType;
  vaccinatedAt: Date;
  /** 次回期限（任意。rabies は未指定時に自動計算） */
  nextDueDate?: Date;
  clinicName?: string;
  notes?: string;
}

/**
 * ワクチン種類のラベル
 */
export const VACCINATION_TYPE_LABELS: Record<VaccinationType, string> = {
  rabies: '狂犬病',
  mixed_2_3: '2〜3種混合',
  mixed_4: '4種混合',
  mixed_5: '5種混合',
} as const;

/**
 * 選択肢として扱うワクチン種類の一覧
 */
export const VACCINATION_TYPES: VaccinationType[] = [
  'rabies',
  'mixed_2_3',
  'mixed_4',
  'mixed_5',
];

/** 狂犬病ワクチンの有効期間（日） */
export const RABIES_VALID_DAYS = 365;
